import React from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { Image } from '@/atoms/Image'
import { Text, CaptionXS } from '@/atoms/Text'
import { slugs } from '@/constants/slugs'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGuildTickets } from '@/views/TicketCheckoutViews/hooks/useGuildTickets'

export const SketchGuildBanner = () => {
  const { t } = useTranslate('tickets')

  const { guildDiscountQuantity } = useGuildTickets(slugs.sketch)

  return (
    <div className="relative z-[39] mb-8 min-h-[120px] @container @[328px]:min-h-[140px] @[732px]:min-h-[140px]">
      <div className={classNames('relative mb-2 rounded-xl @container')}>
        <div className={'absolute h-[140px] w-full overflow-hidden rounded-xl'}>
          <Image
            src={'/v1749678616/sketch-texture-background-01_qbhzd3.jpg'}
            className={`z-10`}
            fill={true}
            style={{ objectFit: 'cover', objectPosition: 'left 40%' }}
            alt={''}
          />
          <Image
            src={'/v1749512073/sketch/test-image.jpg'}
            className={`absolute right-0 top-0 z-[11] h-[140px] w-auto rounded-r-xl opacity-0 @xl:opacity-50 @3xl:opacity-100`}
            height={140}
            width={300}
            style={{ mixBlendMode: 'screen' }}
            alt={''}
          />

          <div className="relative z-10 flex h-full items-center gap-4 @md:-ml-8 @md:px-0">
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.3, ease: 'easeOut', delay: 0.6 }}
            >
              <Image
                src="/v1749676240/sketch-guild-ticket-01_uotgz2.png"
                width={164}
                height={116}
                alt="tickets"
                className="hidden h-[96px] w-[136px] @md:block @2xl:h-[116px] @2xl:w-[164px]"
              />
            </motion.div>

            <motion.div
              className="flex flex-col gap-1 text-white"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, ease: 'easeOut', delay: 0.9 }}
            >
              <Text className="photon-eyebrow-xs md:photon-eyebrow-sm uppercase">
                {t('guildMemberBenefitsBanner', 'Guild Member Benefits')}
              </Text>
              <Text weight="bold" className="photon-title-sm md:photon-title-sm">
                {t(
                  'availableGuildTicketsForSketch',
                  'You Have {{guildDiscountQuantity}} Available Guild Tickets for SKETCH',
                  { guildDiscountQuantity },
                )}
              </Text>
              <div className="flex flex-col gap-0.5">
                <Text className="photon-caption-xs md:photon-caption-sm">
                  {t('selectAShowtimeAndYourSeatsToRedeem', 'Select a showtime and your seats to redeem.')}
                </Text>
                <CaptionXS className="md:!photon-caption-sm !text-[0.625rem] italic" color="core-gray-400">
                  Available for Angel Partnering Theaters.
                </CaptionXS>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  )
}
